import React from 'react';
import { LinkButton } from '../LinkButton';

export class ThankYou extends React.Component{
    render(){
        return(
            <div className="fullwidth">
            <div className="container-fluid  all-centered">
                <article className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <h2>Kiitos osallistumisesta<br />ja onnea arvontaan!</h2>
                            <p>Olemme yhteydessä voittajaan henkilökohtaisesti.</p>
                            <a className="btn btn-green btn-small" onClick={() => { this.props.reload(); }} >Sulje</a>
                        </div>
                    </div>
                </article>
            </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/views/ThankYou.js